export enum DriverMetricType {
  DrivingLoaded = 0,
  DrivingShipperReceiver = 1,
  IdleLoaded = 2,
  OnHourCost = 3,
  AverageFuelGas = 4,
  AverageFuelDiesel = 5,
  AccidentsMistakes = 6,
  AccidentsViolations = 7,
  AccidentsSos = 8,
  ComplianceExpired = 9,
  ComplianceSoonExpired = 10,
  ComplianceNonExpired = 11,
}
